import * as React from 'react';

import './icon-styles.css';

export const BoldIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <path d="M20.22,8.57a3.66,3.66,0,0,1,1.2,3.1c0,2.15-.61,3-2.29,3.31v0c1.93.17,2.61,1.11,2.61,3.31a3.65,3.65,0,0,1-1.18,3.11,7,7,0,0,1-4,.88c-2,0-3.92-.07-5.73-.22-.19,0-.28-.09-.28-.26V8.14c0-.16.09-.24.28-.26,1.81-.14,3.6-.22,5.38-.22A6.78,6.78,0,0,1,20.22,8.57Zm-6.28,2.07V13.8h1.7c1.76,0,2.31-.35,2.31-1.56s-.57-1.6-2.14-1.6Zm0,5.54v3.18h2.27c1.5,0,2.06-.37,2.06-1.53s-.58-1.65-2-1.65Z" />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-bold.tsx